import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';

@Component({
    selector: 'formly-email-panel',
    template: `
    <div class="bg-gray-50 border-s-4 border-gray-500 p-4 mb-6" role="alert">
    <div class="flex justify-start items-center">
      <div class="flex-shrink-0">
        <!-- Icon -->
        <span class="inline-flex justify-center items-center w-8 h-8 rounded-full border-4 border-gray-100 bg-white text-gray-800">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="flex-shrink-0 w-7 h-7"><path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" /></svg>
        </span>
        <!-- End Icon -->
      </div>
      <div class="ms-3 flex justify-center">
        <p class="text-base text-gray-700 dark:text-gray-400">
         {{props.label}}
        </p>
      </div>
    </div>
  </div>

  `,
    standalone: true,
    imports: [FormlyModule]
})
export class PanelEmailComponent extends FieldWrapper {
}
